/**
 * 视频监控组件
 */
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import {
    Style
} from '@/libs/style.js';



let template = /*html*/ `
 <div class="app-technology-conatiner">
    <div id="technology-canvas"></div>
 </div>
 `;


let style = /* css */ `
 .app-technology-conatiner{
        position: absolute;
        top: calc(155px + 170px);
        width: 47%;
        height:630px;
        left:50%;
        transform: translateX(-50%);
        background: rgba(0,0,0,0.02);
        // backdrop-filter: blur(10px);
 }
 #technology-canvas{
     height:100%;
     width:100%;
 }
 `;

export default (Vue) => {
    Vue.customElement('app-technology', {
        template: template,
        data() {
            return {

            }
        },
        mounted() {
            Style(style);
            this.technologyStage = document.getElementById('technology-canvas');
            this.initSpritejs();
        },
        methods: {
            initSpritejs() {
                let width = this.technologyStage.offsetWidth,
                    height = this.technologyStage.offsetHeight;

                const scene = new THREE.Scene();
                this.scene = scene;

                // 设置默认相机
                let camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);

                camera.position.set(1, 5, 10);
                camera.rotation.set(-0.5, 0, 0);



                let renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
                renderer.setSize(width, height);
                this.technologyStage.appendChild(renderer.domElement);

                let light = new THREE.AmbientLight(0xffffff); //模拟漫反射光源
                light.position.set(-10, 10, 10); //使用Ambient Light时可以忽略方向和角度，只考虑光源的位置
                light.intensity = .5;
                scene.add(light);

                let directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
                scene.add(directionalLight);

                let loader = new THREE.ObjectLoader();

                let group = new THREE.Group();
                

                loader.load('./scene.json', function (obj) {
                    obj.position.z = 5
                    console.log(obj)
                    let PerspectiveCamera = obj.children.find(item => item.type === "PerspectiveCamera")

                    // 从配置文件中提取相机,存在则替换默认相机
                    if (PerspectiveCamera) {
                        // camera = PerspectiveCamera
                    }

                    group.add(obj);

                    scene.add(group);

                    // 创建控制器
                    let controls = new OrbitControls(camera, renderer.domElement);
                    controls.update();

                }, function (xhr) {
                    console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                }, function (error) {
                    console.error(error);
                });

                
                function animate() {
                    requestAnimationFrame(animate);

                    scene.rotation.y += .001
                    renderer.render(scene, camera);
                }
                animate();
                this.initGrid();
                // this.skyBox()
            },
            skyBox() {
                //天空盒
                var path = "http://ae01.alicdn.com/kf/";       //设置路径
                var format = '.jpg';                        //设定格式
                var urls = [
                    path + 'HTB1GBRUhpooBKNjSZFPq6xa2XXa5' + format,
                    path + 'HTB1nqDXm98YBeNkSnb4q6yevFXa0' + format,
                    path + 'HTB13tL9vkOWBuNjSsppq6xPgpXay' + format,
                    path + 'HTB1VELXvgaTBuNjSszfq6xgfpXac' + format,
                    path + 'HTB1PLbTvf9TBuNjy1zbq6xpepXao' + format,
                    path + 'HTB1bxWzmZuYBuNkSmRyq6AA3pXa8' + format
                ];
                var textureCube = new THREE.CubeTextureLoader().load(urls);

                this.scene.background = textureCube; //作为背景贴图
            }
            , initGrid() { //网格等辅助对象，开发时使用
                // 方向模拟
                var dir = new THREE.Vector3(1, 2, 0);
                dir.normalize();
                var origin = new THREE.Vector3(0, 0, 0);
                var length = 1;
                var hex = 0xffff00;
                var arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
                // this.scene.add(arrowHelper)
                var axesHelper = new THREE.AxesHelper(5);
                // this.scene.add(axesHelper);

                // =========辅助网格=============
                let helper = new THREE.GridHelper(100, 50);
                this.scene.add(helper);
            }
        }
    });
}